(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rbnl-bf-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rbnl-bf-countdown')) {
  customElements.define('rbnl-bf-countdown', class extends HTMLElement {
    connectedCallback() {
      const end = Date.parse(this.dataset.end);
      if (!Number.isFinite(end) || !/[+-]\d\d:\d\d$|Z$/.test(this.dataset.end)) { this.parentElement.hidden = true; return; }
      const update = () => {
        const left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (!left) { this.textContent = this.dataset.expired; clearInterval(this.timer); return; }
        const values = {days: Math.floor(left / 86400), hours: Math.floor(left / 3600) % 24, minutes: Math.floor(left / 60) % 60, seconds: left % 60};
        for (const [key, value] of Object.entries(values)) this.querySelector('[data-' + key + ']').textContent = String(value).padStart(2, '0');
      };
      this.timer = setInterval(update, 1000); update();
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rbnl-de-bf"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rbnl-de-bf-daily-countdown')){customElements.define('rbnl-de-bf-daily-countdown',class extends HTMLElement{connectedCallback(){this.daily=this.dataset.daily==='true';try{this.dateFormat=new Intl.DateTimeFormat('en-CA',{timeZone:this.dataset.timezone||'Europe/Amsterdam',year:'numeric',month:'2-digit',day:'2-digit'})}catch{this.dateFormat=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Amsterdam',year:'numeric',month:'2-digit',day:'2-digit'})}this.nextMidnight=now=>{const date=this.dateFormat.format(now);let low=now,high=now+27*3600000;while(high-low>100){let mid=Math.floor((low+high)/2);if(this.dateFormat.format(mid)===date)low=mid;else high=mid}return high};this.update=()=>{const now=Date.now();if(this.daily&&(!this.target||now>=this.target))this.target=this.nextMidnight(now);const end=this.daily?this.target:Date.parse(this.dataset.end);const clock=this.querySelector('[data-clock]');if(!clock)return;if(!Number.isFinite(end)){clock.textContent='';return}const remaining=Math.max(0,end-now);if(!remaining){clock.textContent=this.dataset.ended;return}clock.textContent=[Math.floor(remaining/86400000),Math.floor(remaining/3600000)%24,Math.floor(remaining/60000)%60,Math.floor(remaining/1000)%60].map(n=>String(n).padStart(2,'0')).join(' : ')};this.update();this.timer=setInterval(this.update,1000)}disconnectedCallback(){clearInterval(this.timer)}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rbnl-ride-selector"] && !Shopify.designMode) return;
  try {
    
(() => {
  async function connect(root) {
    if(root.dataset.connected)return;
    const builder=document.querySelector('rbnl-autumn-builder-v1');
    if(!builder||!root.querySelector('.rb-ride__image'))return;
    await customElements.whenDefined('rbnl-autumn-builder-v1');
    if(!root.isConnected||typeof builder.activateCategory!=='function')return;
    const choices=[...root.querySelectorAll('[data-ride-category]')];
    const panels=[...builder.querySelectorAll('[data-qn-category-panel]')];
    if(!choices.length||choices.some(b=>!panels.some(p=>p.dataset.qnCategoryPanel===b.dataset.rideCategory)))return;
    root.dataset.connected='true';
    builder.dataset.rideConnected='true';
    const groups=[...root.querySelectorAll('.rb-ride__category-card')];
    const activateGroup=id=>{
      root.dataset.activeGroup=id;
      const labels={clothing:['Kies je kleding','Tik op een kledingstuk.'],bags:['Kies je fietstas','Tik op een tas op de fiets.'],lights:['Kies je verlichting','Kies wat je nodig hebt.'],stands:['Kies je standaard','Kies wat bij je fiets past.']};
      root.querySelector('[data-ride-heading]').textContent=labels[id][0];
      root.querySelector('[data-ride-description]').textContent=labels[id][1];
      const bagsImage=root.querySelector('[data-ride-bags-image]');
      if(bagsImage){bagsImage.hidden=id!=='bags';root.querySelector('[data-ride-main-image]').hidden=id==='bags';}
      root.querySelectorAll('[data-ride-guide]').forEach(guide=>{guide.hidden=guide.dataset.rideGuide!==id;});
      groups.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.rideGroup===id)));
      root.querySelectorAll('.rb-ride__subcategory').forEach(button=>{button.hidden=button.dataset.rideGroup!==id;});
      root.querySelectorAll('.rb-ride__hotspot').forEach(button=>{button.hidden=button.dataset.rideGroup!==id;});
    };
    activateGroup('clothing');
    groups.forEach(button=>button.addEventListener('click',()=>{
      activateGroup(button.dataset.rideGroup);
      root.dispatchEvent(new Event('rbnl:show-main-scene'));
      root.querySelector('.rb-ride__scene').scrollIntoView({behavior:'smooth',block:'start'});
    }));
    const syncChoice=id=>{
      const selected=choices.find(b=>b.dataset.rideCategory===id);
      choices.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.rideCategory===id)));
      if(selected){
        activateGroup(selected.dataset.rideGroup||'clothing');
        root.querySelector('[data-ride-status]').textContent=selected.getAttribute('aria-label');
      }
    };
    syncChoice(builder.activeCategoryId);
    builder.addEventListener('rbnl:category-change',event=>syncChoice(event.detail.id));
    panels.forEach(panel=>{
      if(panel.querySelector('[data-ride-return]'))return;
      const back=document.createElement('button');
      back.type='button';back.className='rb-ride__return';back.dataset.rideReturn='';
      back.textContent='← Kies andere uitrusting';
      back.addEventListener('click',()=>{
        root.dispatchEvent(new Event('rbnl:show-main-scene'));
        const selected=choices.find(b=>b.getAttribute('aria-pressed')==='true')||choices[0];
        root.scrollIntoView({behavior:'auto',block:'start'});
        selected.focus({preventScroll:true});
      });
      panel.prepend(back);
    });
    root.addEventListener('click',event=>{
      const choice=event.target.closest('[data-ride-category]');
      if(!choice)return;
      builder.activateCategory(choice.dataset.rideCategory);
      syncChoice(choice.dataset.rideCategory);
      root.querySelector('[data-ride-status]').textContent=choice.getAttribute('aria-label');
      const area=panels.find(p=>p.dataset.qnCategoryPanel===choice.dataset.rideCategory);
      area.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    });
  }
  document.querySelectorAll('[data-ride-selector]').forEach(connect);
  document.addEventListener('shopify:section:load',()=>document.querySelectorAll('[data-ride-selector]').forEach(connect));
})();

  } catch(e) { console.error(e); }
})();
})();
